import axios from 'axios';
import { stringToHTML } from '../utils/to-html';

const API_URL = 'https://a.klaviyo.com/client';
const HEROKU_URL = 'https://klaviyo-api-gr.herokuapp.com';

const client = axios.create({
  baseURL: API_URL,
  params: { company_id: 'SAYRNQ' },
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    revision: '2024-02-15',
  },
});

export async function registerEmailInKlaviyo(email) {
  const data = {
    data: {
      type: 'profile',
      attributes: {
        email,
      },
      properties: {},
    },
  };
  try {
    const response = await client.post('/profiles', data);
    console.log('Email registered successfully:', response);
  } catch (error) {
    console.error('Error registering email:', error);
  }
}

export async function getBirthdate(email) {
  try {
    const { data } = await axios.post(
      HEROKU_URL + '/shopify/get-birthdate',
      { email }
    );
    return data.birthdate;
  } catch {
    return false;
  }
}

export async function getLanguage(email) {
  try {
    const { data } = await axios.get(
      `${HEROKU_URL}/shopify/get-language?email=${email}`
    );
    return data;
  } catch {
    return false;
  }
}

export async function setLanguage(email, locale) {
  try {
    const res = await axios.get(
      `${HEROKU_URL}/shopify/set-language?email=${email}&locale=${locale}`
    );
    return res;
  } catch {
    return false;
  }
}

export const KlaviyoAPI = {
  token: 'SAYRNQ',

  /**
   * Returns a list of klaviyo's list, including an object indicating if the user is subscribed
   * to each list. It also filters the lists based on the given language and strips the name of the language
   * from the list name
   *
   * @param {string} email - customer email
   * @param {string} lang - language from klaviyo api
   * @returns {Promise<object>}
   */
  async getLists(email) {
    const response = await axios.post(`${HEROKU_URL}/klaviyo/lists`, { email });
    return response.data;
  },

  /**
   * Subscribes a profile to a list, by email
   *
   * @param {string} email customer email
   * @param {string} listId klaviyo list id
   * @returns {Promise<object>}
   */
  async subscribeToList(email, listId) {
    const data = {
      data: {
        type: 'subscription',
        relationships: { list: { data: { type: 'list', id: listId } } },
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
              },
            },
          },
        },
      },
    };

    const response = await client.post(`/subscriptions`, data).then((r) => r);
    return response;
  },
  /**
   * Unsubscribes a profile from a list, by email
   *
   * @param {string} email customer email
   * @param {string} listId klaviyo list email
   * @returns {Promise<object>}
   */
  async unsubscribeFromList(email, listId) {
    const response = await axios.post(
      `${HEROKU_URL}/klaviyo/list/${listId}/unsubscribe`,
      { email }
    );
    return response.data;
  },

  /**
   *
   * @param {string} email - email of the subscriber
   * @param {number} variantId - variant id to subscribe to
   */
  async subscribeToBackInStock(email, variantId) {
    const data = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId,
            },
          },
        },
      },
    };

    const response = await client.post('/back-in-stock-subscriptions', data);

    return response;
  },

  /**
  * Subscribes an email to a list for marketing
  *
  * @param {string} email client's email
  * @returns {Promise<Array<object>>}
  */
  async subscribeToMarketingList(email) {
    if (!email) return

    try {
      const response = await axios.post(
        `${HEROKU_URL}/klaviyo/list/subscribe/marketing`,
        { email }
      )
      return response;
    } catch (error) {
      console.warn("ERROR IN BACKEND", error)
      return null
    }
  }
};

export async function sendAddCartTrackEvent() {
  const _learnq = window._learnq || [];
  try {
    const { data } = await axios({
      url: `${window.location.origin}/cart.js`,
    });

    let formatCurrency = new Intl.NumberFormat(
      `${Shopify.locale}-${Shopify.country}`,
      {
        style: 'currency',
        currency: `${Shopify.currency.active}`,
      }
    );

    const dataEvent = {
      token: encodeURIComponent(data.token),
      items: data.items.map((item) => {
        const name = stringToHTML(item.title);

        return {
          name: name.textContent,
          productID: item.product_id,
          categories: item.product_type,
          imageURL: item.image,
          url: `${window.location.origin}${item.url}`,
          brand: item.vendor,
          price: formatCurrency.format(item.presentment_price),
          quantity: item.quantity,
        };
      }),
    };
    console.log(dataEvent);
    _learnq.push(['track', 'Added to Cart', dataEvent]);
  } catch (error) {
    console.log('Error sendAddCartTrackEvent:', error);
  }
}
